module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pA0S"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_18",
      "id": "CC_18"
    }
  }, [_vm._v(" Myers Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pA4qz"
    }
  }, [_c('i', [_vm._v(" It’s the spot. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAMDc"
    }
  }, [_c('b', [_vm._v(" ½ cup sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA8i"
    }
  }, [_c('b', [_vm._v(" 2 cups water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAKF1"
    }
  }, [_c('b', [_vm._v(" ½ teaspoon cinnamon ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pALX"
    }
  }, [_c('b', [_vm._v(" 2 to 3 cups orange juice, no pulp ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAag8"
    }
  }, [_c('b', [_vm._v(" 1 cup pineapple juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA87"
    }
  }, [_c('b', [_vm._v(" 6 cups apple juice or cider ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pA8eo"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("B")]), _vm._v("oil water and sugar together until sugar melts, stirring often. Mix cinnamon in well; add juices. Refrigerate overnight or several hours to meld flavors. Decorate punch bowl with cinnamon sticks, orange and/or lemon slices studded with whole cloves, and frozen cider ice molds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAn8W"
    }
  }, [_vm._v(" Makes 25 punch cups.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAU-K"
    }
  }, [_c('i', [_vm._v("Janine Johnson—Orlando, Florida")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pAS9"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-20-1.jpg",
      "id": "AS9",
      "src": "images/img-20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pAkR"
    }
  }, [_c('i', [_vm._v("“Now, take down your fishin’ pole and meet me at the fishin’ hole.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b34ffcc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter18.vue
// module id = 117
// module chunks = 0